import React, { useEffect, useState } from "react";
import { images } from "../../../constants";

const BackgroundContainer = ({ children }) => {
  const [width, setWidth] = useState(window.innerWidth);
  const [isMobile, setisMobile] = useState(true);
  function handleWindowSizeChange() {
    setWidth(window.innerWidth);
  }

  useEffect(() => {
    window.addEventListener("resize", handleWindowSizeChange);
    return () => {
      window.removeEventListener("resize", handleWindowSizeChange);
    };
  }, []);

  useEffect(() => {
    if (width <= 768) {
      return setisMobile(true);
    }
    setisMobile(false);
  }, [width]);

  return (
    <div
      style={{
        backgroundImage: `url(${
          !isMobile ? images.bgDesktop : images.bgMobile
        })`,
        width: "100%",
        backgroundSize: "cover",
      }}
    >
      {children}
    </div>
  );
};

export default BackgroundContainer;
